<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <Row :title="$t('AgreementNo')" :val="delivery.AgreementNo"></Row>
        <Row :title="$t('AgreementName')" :val="delivery.AgreementName"></Row>
        <Row :title="$t('DeliveryNo')" :val="delivery.No"></Row>
        <Row :title="$t('DeliveryName')" :val="delivery.Name"></Row>
        <Row :title="$t('Comment')" :val="delivery.Comment"></Row>
        <Row :title="$t('Vehicles')" :val="delivery.VehiclesNum.join(', ')"></Row>
        <Row :title="$t('Facility')"  :val="delivery.Facility"></Row>
      </v-col>
      <v-col cols="12" md="6">
        <Row :title="$t('Earliest load time')" :val="formatDateNonUtc(delivery.LoadTimeEarliest)"></Row>
        <Row :title="$t('Amount delivered')" :val="delivery.AmountDelivered+' kg'+' / '+delivery.AmountTotal+' kg'"></Row>
        <Row :title="$t('ArticleNo')" :val="delivery.ArticleNo"></Row>
        <Row :title="$t('ArticleName')" :val="delivery.ArticleName"></Row>
        <Row :title="$t('CustomerName')" :val="delivery.CustomerName"></Row>
        <Row :title="$t('Foreman')" :val="delivery.Foreman"></Row>
        <Row :title="$t('LineForeman')" :val="delivery.LineForeman"></Row>
        <Row :title="$t('Storage')" :val="delivery.Storage"></Row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Row from '@/modules/asphalt-delivery/components/Row'
import formatDate from '@/core/mixins/formatDate'

export default {
  mixins: [formatDate],
  components: {
    Row
  },
  props: ['delivery']
}
</script>
